import type { UseQueryOptions } from "@tanstack/react-query";
import { skipToken } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import usePersistedQuery from "$src/core/hooks/use-persisted-query";
import type { ThemeDto } from "$src/core/models/dto";

const queryKey = () => ["theme"];

const useThemeQuery = (
  options?: Omit<UseQueryOptions<Awaited<ThemeDto>>, "queryKey" | "queryFn">,
) => {
  const { api } = useApi();

  return usePersistedQuery({
    queryKey: queryKey(),
    queryFn: api.getTheme ? () => api.getTheme!() : skipToken,
    ...options,
  });
};

export default useThemeQuery;
